module.exports = __webpack_public_path__ + "f572638f/img/delete-icon.eb7de062.svg";